/* eslint-disable */
// @ts-nocheck
import dash_api from '../../main/support/dash_api';
import NotificationActions from '../../main/actions/NotificationActions';
import { ReduxAsyncAction, getCookie } from '../support/utils';
import { track } from '../../common/support/mixpanel';
const WHITELISTED_DEVICES_PATH = '/v1/whitelisted-devices';

/**
 * get all the whistelisted devices added for the app
 */
const GetWhitelistedDevices = new ReduxAsyncAction('GET_WHITELISTED_DEVICES');
GetWhitelistedDevices.registerRequest(() => {
  return dash_api.get(`${WHITELISTED_DEVICES_PATH}`).then((res) => {
    return {
      devices: res.data,
    };
  });
});
export const GET_WHITELISTED_DEVICES = GetWhitelistedDevices.constants;
export const getWhitelistedDevices = GetWhitelistedDevices.request;

/**
 * add a new whitelisted device id
 */
const SaveWhitelistedDevice = new ReduxAsyncAction('SAVE_WHITELISTED_DEVICES');
SaveWhitelistedDevice.registerRequest(function (options) {
  const { device_id, device_name, created_timestamp, os } = options;
  return dash_api
    .post(`${WHITELISTED_DEVICES_PATH}`, {
      device_id,
      device_name,
      created_timestamp,
      os,
    })
    .then((res) => {
      track('Whitelist Device Added', {
        bmp: getCookie('bmp'),
      });
      NotificationActions.showNotification(`Device added successfully!`, 'success');
      return {
        device: res.data,
      };
    })
    .catch((err) => {
      track('Error in adding Whitelist Device', {
        bmp: getCookie('bmp'),
      });
      NotificationActions.showNotification(`Failed to add device!`, 'error');
    });
});
export const SAVE_WHITELISTED_DEVICES = SaveWhitelistedDevice.constants;
export const saveWhitelistedDevices = SaveWhitelistedDevice.request;

/**
 * update the refreshed_at timestamp by device_id
 */
const UpdateWhitelistedDeviceRefreshedAt = new ReduxAsyncAction('UPDATE_WHITELISTED_DEVICES');
UpdateWhitelistedDeviceRefreshedAt.registerRequest(function (device_id, refreshed_timestamp) {
  return dash_api
    .put(`${WHITELISTED_DEVICES_PATH}`, {
      device_id,
      refreshed_timestamp,
    })
    .then((res) => {
      track('Whitelist Device Persona reset', {
        bmp: getCookie('bmp'),
      });
      NotificationActions.showNotification(`Data for device Id ${device_id} is successfully reset!`, 'success');
      return {
        device: res.data,
      };
    });
});
export const UPDATE_WHITELISTED_DEVICES = UpdateWhitelistedDeviceRefreshedAt.constants;
export const updateWhitelistedDevices = UpdateWhitelistedDeviceRefreshedAt.request;

/**
 * delete the whitelisted device
 */
const DeletedWhitelistedDevice = new ReduxAsyncAction('DELETE_WHITELISTED_DEVICES');
DeletedWhitelistedDevice.registerRequest(function (device_id) {
  return dash_api.delete(`${WHITELISTED_DEVICES_PATH}?device_id=${device_id}`).then((res) => {
    track('Whitelist Device deleted', {
      bmp: getCookie('bmp'),
    });
    NotificationActions.showNotification(`Device ID ${device_id} deleted successfully!`, 'success');
    return {
      device_id: device_id,
    };
  });
});
export const DELETE_WHITELISTED_DEVICES = DeletedWhitelistedDevice.constants;
export const deleteWhitelistedDevices = DeletedWhitelistedDevice.request;
